export const dateFormat = "YYYY-MM-DD";
export const recordsLimit = 15;